import basicCharsRegexp from "../common/basicCharsRegexp";
import { AppNameNotValidError } from "../common/errors";
/*
 *  An app name is valid when:
 *  - has 0 < length < 256
 *  - contains only characters from the basicChars subset (see utils)
 */
export function isAppNameValid(name) {
    return basicCharsRegexp.test(name);
}
export function validateAppName(name) {
    if (!isAppNameValid(name)) {
        throw new AppNameNotValidError(name);
    }
}
//# sourceMappingURL=App.js.map